import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { completeGoogleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        await completeGoogleSession(sessionId);
        window.history.replaceState({}, document.title, "/chat");
        toast.success("Welcome to the tavern.");
        navigate("/chat", { replace: true });
      } catch (e) {
        toast.error("Sign-in failed. Try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [completeGoogleSession, navigate, location.hash]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="font-display tracking-[0.4em] uppercase text-xs text-silver animate-pulse" data-testid="auth-callback-loading">
        Lighting the torches...
      </div>
    </div>
  );
}
